import {
  STEP_LOG_ALL,
  STEP_LOG_ERROR,
  STEP_LOG_GET,
  STEP_LOG_LOADING,
} from '../../actions/types';

const initialState = {
  step: null,
  isLoading: true,
  isCompleted: true,
};

export default function StepLogReducer(state = initialState, action) {
  switch (action.type) {
    case STEP_LOG_LOADING:
      return { isLoading: true, isCompleted: false };
    case STEP_LOG_ERROR:
      return { isLoading: false, isCompleted: false, ...action.payload };
    case STEP_LOG_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case STEP_LOG_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    default:
      return state;
  }
}
